import _ from 'lodash';
import CalculatorSelectInput from '../../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';
import CalculatorStandardInput from '../../../calculatorInputs/CalculatorStandardInput';
import React from 'react';

const EqualValue = ({showLabel,availableValueOptions, fieldName, readOnly = false}) => {
    return !_.isEmpty(availableValueOptions) ? (
      <CalculatorSelectInput
        fieldName={`${fieldName}.${0}`}
        label={`${
          showLabel
            ? i18next.t('calculator.dialog.create.label.values')
            : ''
        }`}
        placeholder={i18next.t(
          `calculator.dialog.create.placeholder.selectValues`
        )}
        options={availableValueOptions}
        uxVariant="criteriaInput"
        variant="standard"
        isRequired
        validate={() => {
          return null;
        }}
        labelVariant="chip"
        triggerOnContinue
        disabled={readOnly}
      />
    ) : (
      <CalculatorStandardInput
        fieldName={`${fieldName}.${0}`}
        isRequired
        uxVariant="criteriaInput"
        variant="standard"
        label={`${
          showLabel
            ? i18next.t('calculator.dialog.create.label.values')
            : ''
        }`}
        placeholder={i18next.t(
          `calculator.dialog.create.placeholder.selectValues`
        )}
        validate={() => {
          return null;
        }}
        triggerOnContinue
        disabled={readOnly}
      />
    );
}

export default EqualValue;